import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './dashboard/reportWebVitals';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import { Landing } from './landing/Landing';
import { SignUp, SignIn } from './landing/auth';
import { Waitlist } from './dashboard/Waitlist';
import { FirebaseContextProvider } from './firebase/FirebaseContext';
import { Form } from './form/Form';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <FirebaseContextProvider>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="sign-up" element={<SignUp />} />
          <Route path="sign-in" element={<SignIn />} />
          <Route path="dashboard" element={<Waitlist />} />
          <Route path=":account/:property" element={<Form />} />
        </Routes>
      </FirebaseContextProvider>
    </BrowserRouter>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
